import { useState } from "react";

export const Toggle = (props) => {
    const { enabled, setEnabled, name } = props;

    return (
        <div className="flex mb-3">
            <div className="flex flex-col">
                {name && (
                    <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">
                        {name}
                    </label>
                )}

                <label className="inline-flex relative items-center cursor-pointer">
                    <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={enabled}
                        readOnly
                    />
                    <div
                        onClick={() => {
                            setEnabled(!enabled);
                        }}
                        className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-green-300 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"
                    ></div>
                </label>
            </div>
        </div>
    );
};
